import { FC, useState } from 'react';
import { Box } from '@mui/material';

import styles from './TripRightPanelCalendar.module.scss';
import TripCalendar from './components/TripCalendar/TripCalendar';
import TripDateActivities from './components/TripDateActivities/TripDateActivities';
import { TripDetail, TripStop } from '../../../../../types/trip.types';
import { useIsMobile } from '../../../../../hooks/useWindowWidth';

interface TripRightPanelCalendarProps {
  trip: TripDetail;
  onShowStopDetails: (activity: TripStop) => void;
  onShowFilters: () => void;
  onTogglePanel: () => void;
  showCloseButton?: boolean;
}

const TripRightPanelCalendar: FC<TripRightPanelCalendarProps> = ({
  trip,
  onShowStopDetails,
  onShowFilters,
  onTogglePanel,
  showCloseButton = false,
}) => {
  const isMobile = useIsMobile();
  const [selectedDate, setSelectedDate] = useState<Date>(() => {
    if (trip?.start_date) {
      const tripStart = new Date(trip.start_date);
      if (!Number.isNaN(tripStart.getTime())) {
        return tripStart;
      }
    }
    return new Date();
  });

  const handleDateSelect = (date: Date | null) => {
    if (date) {
      setSelectedDate(date);
    }
  };

  const getContainerClass = () => {
    let className = styles.tripRightPanelCalendar;

    if (isMobile) {
      className += ` ${styles.mobileCalendar}`;
    }

    return className;
  };

  return (
    <Box className={getContainerClass()}>
      <Box className={styles.calendarSection}>
        <TripCalendar
          trip={trip}
          selectedDate={selectedDate}
          onDateSelect={handleDateSelect}
          onShowFilters={!isMobile ? onShowFilters : () => {}}
          onTogglePanel={onTogglePanel}
          showCloseButton={isMobile && showCloseButton}
          isMobile={isMobile}
        />
      </Box>

      <Box className={styles.activitiesSection}>
        <TripDateActivities
          trip={trip}
          selectedDate={selectedDate}
          onShowStopDetails={onShowStopDetails}
        />
      </Box>
    </Box>
  );
};

export default TripRightPanelCalendar;
